
import config from '@/core/config';
import useMedia from '@/hooks/useMedia';
import { Box, Container, Divider, Link, Typography } from '@mui/material';

import Form from './Form';

const View = () => {
    const media = useMedia()

    const contacts: {
        label: string;
        type: string;
        value: string;
        link?: string;
    }[] = [
        {
            label: 'Facebook',
            type: 'link',
            value: config.contacts.facebook,
        },
        {
            label: 'Telegram',
            type: 'link',
            value: config.contacts.telegram,
        },
        {
            label: 'Email',
            type: 'email',
            value: config.contacts.email,
        },
        {
            label: 'Phone',
            type: 'phone',
            value: config.contacts.phone,
        },
        {
            label: 'Address',
            type: 'address',
            value: config.contacts.address,
        }
    ].filter(item => item.value).map(contact => {
        switch (contact.type) {
            case 'link':
                return {
                    ...contact,
                    value: contact.value.replace(/^https?:\/\//, ''),
                    link: contact.value,
                }
            case 'email':
                return {
                    ...contact,
                    link: `mailto:${contact.value}`,
                }
            case 'phone':
                return {
                    ...contact,
                    link: `tel:${contact.value}`,
                }
            default:
                return contact
        }
    });

    return (
        <Container maxWidth="lg">
            <Box sx={{
                ...(media.down.md ? {
                    py: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                } : {
                    py: 20,
                    display: 'grid',
                    gridTemplateColumns: '1fr minmax(300px, 500px)',
                    gap: 20,
                }),

            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5,
                }}>
                    <Typography variant="h2" gutterBottom>
                        Contact Us
                    </Typography>
                    <Typography variant="body1">
                        We are always here to help you. If you have any questions, concerns, <br />
                        or just want to say hi, please feel free to contact us.
                    </Typography>
                    <Divider />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 5,
                    }}>
                        {contacts.map(contact => (
                            <Box key={contact.label}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    {contact.label}
                                </Typography>
                                <Link href={contact.link}
                                    variant="body1"
                                    color="text.primary"
                                    target="_blank" rel="noopener noreferrer">
                                    {contact.value}
                                </Link>
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box>
                    <Form />
                </Box>
            </Box>
        </Container>
    )
}

export default View